export default class Size {
  private currentSize: number = this.initialSize
  private sizeMultiplier = 1
  private readonly shrinkMultiplier = 1 / this.growthMultiplier

  constructor(
    private readonly initialSize: number,
    private readonly maxSize: number,
    private readonly growthMultiplier: number,
  ) {}

  getNextSize(): number {
    this.currentSize *= this.sizeMultiplier

    if (this.currentSize >= this.maxSize) {
      this.startShrinking()
    }

    if (this.currentSize <= this.initialSize) {
      this.lock()
    }

    return this.currentSize
  }

  startGrowing(): void {
    this.sizeMultiplier = this.growthMultiplier
  }

  private startShrinking(): void {
    this.sizeMultiplier = this.shrinkMultiplier
  }

  private lock(): void {
    this.sizeMultiplier = 1
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/graphics/Size.ts